import deepFreeze from 'deep-freeze';

import { defaultConfig, MainConfig } from '#/service/config';
import { RawConfig } from '#/service/config/raw.types';
import { initializeConfig } from '#/service/config/transform';

import { geti18NextConfig } from './i18nextConfig';
import { getMetaAttributes } from './meta';

// If any of these variables are modified, remember to change them in publicPath.js as well
const ONE_META_NAME = 'one-data';

enum MetaKey {
  Config = 'data-one-config',
  Translations = 'data-one-translations',
  Locale = 'data-one-locale',
  StaticFilePrefix = 'data-one-static-file-prefix',
  Version = 'data-one-static-bundle-version',
  RouterVersion = 'data-one-router-version',
}

// Describes the structure of the global one object
type OneObjectInterface = Readonly<{
  env: {};
  config: MainConfig;
}>;

const defaultOne: OneObjectInterface = {
  env: {},
  config: defaultConfig,
};

type MetaAttrTupleType = [RawConfig, any, string, string, string, string];

function getDataFromMetaAttributes(): OneObjectInterface | null {
  const [
    config,
    translations,
    locale,
    staticFilePrefix,
    version,
    routerVersion,
  ] = getMetaAttributes<MetaAttrTupleType>(ONE_META_NAME, [
    {
      name: MetaKey.Config,
      parse: true,
    },
    {
      name: MetaKey.Translations,
      parse: true,
    },
    MetaKey.Locale,
    MetaKey.StaticFilePrefix,
    MetaKey.Version,
    MetaKey.RouterVersion,
  ]);

  if (!config) {
    return null;
  }

  console.debug('Initial locale', locale);
  const i18nConfig = geti18NextConfig(
    locale || 'en',
    translations?.translations
  );

  return {
    env: {},
    config: initializeConfig(
      config,
      i18nConfig,
      staticFilePrefix,
      version,
      routerVersion
    ),
  };
}

const oneObject: OneObjectInterface = deepFreeze(
  getDataFromMetaAttributes() || defaultOne
) as OneObjectInterface;

export default oneObject;
